import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class TransportService extends RestService {
    openTransportFile(transportId: number, filename: string) {
        const payload = {
            transportId,
            filename
        }

        return this.post(`${this.TRANSPORT_FILE_URL}`, payload).pipe(
            tap(res => {
                if (res.error) {
                    throw Error('[Transport Service] - Transport File Fails');
                }
            }),
            map(res => (res instanceof HttpErrorResponse || res.error) ? null : res.data.url),
        )
    }
}
